import { startGeneration } from "@/orval/gen"
import { Loader } from "@mantine/core"
import { createFileRoute, redirect } from "@tanstack/react-router"

export interface ExportSearchParams {
  planId: number
  start: string
  end: string
  format: "PDF" | "Word"
}

export const Route = createFileRoute("/app/art/schedules/export")({
  pendingComponent: PendingComponent,
  validateSearch: (search: ExportSearchParams) => search,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search } }) => {
    const response = await startGeneration({
      planId: search.planId,
      start: String(search.start),
      end: String(search.end),
      format: search.format === "PDF" ? "pdf" : "doc",
      download: false,
    })

    throw redirect({
      to: "/app/art/schedules/$taskId",
      params: { taskId: response.taskId },
      search: { name: response.planName },
    })
  },
})

function PendingComponent() {
  return <Loader />
}
